module.exports = __webpack_public_path__ + "img/home-sidebar-logged-out.3ec0e78c.jpg";